
import { defineComponent } from 'vue';
import AccentButton from './AccentButton.vue';
import TextInput from './TextInput.vue';
import TopBlock from './TopBlock.vue';
import { backend } from '@/main';

export default defineComponent({
  components: { TopBlock, TextInput, AccentButton },
  data() {
    return {
      clicked: false,
      error: false,
      errorMessage: '',
      submitted: false,
      name: '',
      phone: '',
      text: '',
      email: '',
    };
  },
  name: 'TheContactsSection',
  methods: {
    async clickHandler() {
      this.submitted = true;
      const directus = await backend;
      if (!directus) {
        this.clicked = true;
        this.error = true;
        this.errorMessage = 'Не удалось подключиться к серверу!';
        setTimeout(() => {
          this.clicked = false;
          this.error = false;
        }, 2000);
        return;
      }
      if (this.name.length > 0
        && this.phone.length > 0
        && this.text.length > 0
        && this.email.length > 0) {
        this.clicked = true;
        // eslint-disable-next-line no-unused-expressions
        try {
          await directus.items('messages').createOne({
            name: this.name,
            phone: this.phone,
            email: this.email,
            text: this.text,
          });
          this.text = '';
        } catch (error) {
          console.log(error);
          this.error = true;
          this.errorMessage = 'Произошла неизвестая ошибка!';
        }
        setTimeout(() => {
          this.clicked = false;
          this.error = false;
        }, 4000);
      }
    },
  },
});
